import { Tabs, Typography } from "antd";
import {
  FileDoneOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import FinalWeightmentTab from "./FinalWeightmentTab";
import SupervisorVerificationTab from "./SupervisorVerificationTab";

const { Title, Text } = Typography;

const RakeWorkflowDocuments = () => {
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Title level={3} style={{ marginBottom: 4 }}>
          Workflow Documents
        </Title>
        <Text type="secondary">
          Upload rake workflow slips and extract their details
        </Text>
      </div>

      <Tabs
        defaultActiveKey="final_weightment"
        items={[
          {
            key: "final_weightment",
            label: (
              <span>
                <FileDoneOutlined /> Final Weightment
              </span>
            ),
            children: <FinalWeightmentTab />,
          },
          {
            key: "supervisor_verification",
            label: (
              <span>
                <SafetyCertificateOutlined /> Supervisor Verification
              </span>
            ),
            children: <SupervisorVerificationTab />,
          },
        ]}
      />
    </div>
  );
};

export default RakeWorkflowDocuments;
